import actionTypes from '@types/basic/layout'
import { applicationSelector } from '@utils/menuUtils'
import crumbList from './crumbList'

const initialState = {
  // 左侧菜单收起状态
  collapsed: false,
  // loading 加载状态
  loading: false,
  // 快捷选项卡
  tabs: { activeKey: '', list: [] },
  // 页面title
  title: '',
  // 面包削导航
  crumbList: {
    current: -1,
    stack: []
  },
  // 控制是否展示面包屑
  hideCrumb: false,
  /**
   * 控制三级路由容器样式
   * default 存在 padding
   * empty 无 padding
   */
  layoutMode: 'default',
  application: '',
  // 左侧数据
  menuData: [],
  // header 选中
  selectedKeys: '',
  openKeys: [],
  // 收否是详情页面
  levelPage: false,
  defaultKeys: [],
  defaultOpenKeys: []
}

const layout = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.TOGGLE: {
      return {
        ...state,
        collapsed: !state.collapsed
      }
    }
    case actionTypes.SET_LAYOUT: {
      return {
        ...state,
        hideCrumb: Boolean(action.payload.hideCrumb),
        layoutMode: action.payload.layoutMode || 'default'
      }
    }
    case actionTypes.SET_APPLICATION: {
      return {
        ...state,
        application: action.payload
      }
    }
    case actionTypes.UPDATE_LOADING: {
      return {
        ...state,
        loading: action.payload.loading
      }
    }
    case actionTypes.UPDATE_TAB_KEY: {
      return {
        ...state,
        tabs: {
          ...state.tabs,
          activeKey: action.payload.activeKey
        }
      }
    }
    case actionTypes.UPDATE_TAB_LIST: {
      let list = state.tabs.list
      const findList = list.find(tab => tab.key === action.payload.key)
      if (!findList) {
        list.push(action.payload)
      }
      return {
        ...state,
        title: action.payload.title,
        tabs: {
          list: list,
          activeKey: action.payload.key
        }
      }
    }
    case actionTypes.DELETE_TAB_ITEM: {
      let { activeKey, list } = state.tabs
      let lastIndex
      list.forEach((pane, i) => {
        if (pane.key === action.payload.targetKey) {
          lastIndex = i - 1
        }
      })
      const panes = list.filter(pane => pane.key !== action.payload.targetKey)
      if (lastIndex >= 0 && activeKey === action.payload.targetKey) {
        activeKey = panes[lastIndex].key
      }
      return {
        ...state,
        tabs: {
          list: panes,
          activeKey
        }
      }
    }
    case actionTypes.SET_MENU_DATA: {
      let defaultKeys = []
      let defaultOpenKeys = []

      const currentApplication = applicationSelector(
        action.payload,
        state.application
      )

      let menu = currentApplication?.menu || []
      if (menu && menu.length) {
        menu = menu[0]
        if (menu.children && menu.children.length) {
          defaultKeys = [`sub_view_${menu.children[0].views[0].id}`]
          defaultOpenKeys = [`sub_${menu.id}`, `sub_${menu.children[0].id}`]
        } else if (menu.views && menu.views.length > 1) {
          defaultKeys = [`sub_view_${menu.views[0].id}`]
          defaultOpenKeys = [`sub_${menu.id}`]
        } else {
          defaultKeys = [`${menu.id}`]
        }
      }
      return {
        ...state,
        menuData: action.payload,
        defaultKeys,
        defaultOpenKeys
      }
    }
    case actionTypes.SET_SELECTED_KEYS: {
      return {
        ...state,
        selectedKeys: action.payload
      }
    }
    case actionTypes.SET_OPEN_KEYS: {
      return {
        ...state,
        openKeys: action.payload
      }
    }
    case actionTypes.SET_LEVEL_PAGE: {
      return {
        ...state,
        levelPage: action.payload
      }
    }
    default: {
      return {
        ...state,
        crumbList: crumbList(state.crumbList, action)
      }
    }
  }
}

export default layout
